module.exports = __webpack_public_path__ + "8398bca3ba9c4071205abbc0cb7d62f7.png";